import dayjs from "dayjs";
import WidgetSvg from "assets/img/SquaresFour.svg";
import AIVideoSvg from "assets/img/Robot.svg";
import SocialMediaPostSvg from "assets/img/PaperPlaneTilt.svg";
import LivestreamSvg from "assets/img/Television.svg";
import DMAutomationSvg from "assets/img/FlowArrow.svg";

export const encodePlusSignInUrl = (image_url = "")=>{
  return image_url.replace(/\+/g, "%2B");
}

export const rbacArray = [
    {
      key: "general",
      parentKey: null,
      title: "General Settings",
      isSelected: false,
      showAccordian: true,
      showSelectedNumber: false,
      showBackgroundColor: true,
      items: [
        {
          key: "home",
          parentKey: "general",
          title: "Home",
          isSelected: false,
          showAccordian: true,
          showSelectedNumber: true,
          items: [
            {
              key: "homepage",
              parentKey: "home",
              title: "Home",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
          ],
        },
        {
          key: "asset_library",
          parentKey: "general",
          title: "Asset Library",
          isSelected: false,
          showAccordian: true,
          showSelectedNumber: true,
          items: [
            {
              key: "view_all_media",
              parentKey: "asset_library",
              title: "View all media",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "add_media",
              parentKey: "asset_library",
              title: "Add Media",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [
                {
                  key: "add_media_notify_admin",
                  parentKey: "add_media",
                  title: "Notify admin when adding",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
              ],
            },
            {
              key: "delete_media",
              parentKey: "asset_library",
              title: "Delete Media",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "media_tagging",
              parentKey: "asset_library",
              title: "Media tagging",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
          ],
        },
        {
          key: "settings",
          parentKey: "general",
          title: "Settings",
          isSelected: false,
          showAccordian: true,
          showSelectedNumber: true,
          items: [
            {
              key: "integration",
              parentKey: "settings",
              title: "Social media & Store Integration",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [
                {
                  key: "show_linked_accounts",
                  parentKey: "integration",
                  title: "Show all linked accounts",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
                {
                  key: "allow_new_account_link",
                  parentKey: "integration",
                  title: "Allow to link new account",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
                {
                  key: "allow_delete_linked_account",
                  parentKey: "integration",
                  title: "Allow to delete linked account",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
              ],
            },
            {
              key: "account_setting",
              parentKey: "settings",
              title: "Account Settings",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "edit_app_prefrence",
              parentKey: "settings",
              title: "Editing App preferences",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
          ],
        },
      ],
    },
    {
      key: "module_permission",
      title: "Module permissions",
      isSelected: false,
      showAccordian: true,
      showSelectedNumber: false,
      showBackgroundColor: true,
      items: [
        {
          key: "creation_module",
          title: "Creation Module",
          isSelected: false,
          showAccordian: true,
          showSelectedNumber: false,
          items: [
            {
              key: "livestream",
              title: "Livestream",
              isSelected: false,
              showAccordian: true,
              showSelectedNumber: true,
              items: [
                {
                  key: "add_as_module",
                  title: "Add as module",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
                {
                  key: "add_as_module",
                  title: "Add as host",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
                {
                  key: "extra_settings",
                  title: "Extra settings",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [
                    {
                      key: "change_view_count",
                      title: "Change view count",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                    {
                      key: "record_livestream",
                      title: "Record livestrem",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          key: "publish_module",
          title: "Publish Module",
          isSelected: false,
          showAccordian: true,
          showSelectedNumber: false,
          items: [
            {
              key: "social_media",
              title: "Social Media",
              isSelected: false,
              showAccordian: true,
              showSelectedNumber: true,
              items: [
                {
                  key: "link_account",
                  title: "Link account",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [
                    {
                      key: "change_view_account",
                      title: "Show all link account",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                    {
                      key: "link_new_account",
                      title: "Allow to link new account",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                    {
                      key: "delete_link_count",
                      title: "Allow to delete linked account",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                  ],
                },
                {
                  key: "create_post",
                  title: "Create a post",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [
                    {
                      key: "create_drafts",
                      title: "Create drafts",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                    {
                      key: "schedule_posts",
                      title: "Schedule posts",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                    {
                      key: "publish_posts",
                      title: "Publish posts",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                    {
                      key: "queue_a_post",
                      title: "Queue a post",
                      isSelected: false,
                      showAccordian: false,
                      showSelectedNumber: false,
                      items: [],
                    },
                  ],
                },
                {
                  key: "delete_post",
                  title: "Delete post",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
                {
                  key: "access_analytics",
                  title: "Access to analytics",
                  isSelected: false,
                  showAccordian: false,
                  showSelectedNumber: false,
                  items: [],
                },
              ],
            },
          ],
        },
        {
          key: "widgets",
          title: "Widgets",
          isSelected: false,
          showAccordian: true,
          showSelectedNumber: true,
          items: [
            {
              key: "see_all_widgets",
              title: "See all widgets",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "create_widgets",
              title: "Create widgets",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "delete_widgets",
              title: "Delete widgets",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "access_widget_analytics",
              title: "Access analytics",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
            {
              key: "setup_shopify_configuration",
              title: "Setup shopify configuration",
              isSelected: false,
              showAccordian: false,
              showSelectedNumber: false,
              items: [],
            },
          ],
        },
      ],
    },
];

export const rangePresets = [
  {
    label: "All",
    value: null
  },
  {
    label: "Today",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Yesterday",
    value: [dayjs().subtract(1, "d"), dayjs().subtract(1, "d")],
  },
  {
    label: "Last 7 Days",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "Last 14 Days",
    value: [dayjs().add(-14, "d"), dayjs()],
  },
  {
    label: "Last 30 Days",
    value: [dayjs().add(-30, "d"), dayjs()],
  },
  {
    label: "Last 60 Days",
    value: [dayjs().add(-60, "d"), dayjs()],
  },
];

export const LanguageOptions = [
  { key: "ar", label: "Arabic" },
  { key: "bg", label: "Bulgarian" },
  { key: "cs", label: "Czech" },
  { key: "da", label: "Danish" },
  { key: "de", label: "German" },
  { key: "el", label: "Greek, Modern" },
  { key: "en", label: "English" },
  { key: "es", label: "Spanish; Castilian" },
  { key: "fi", label: "Finnish" },
  { key: "fr", label: "French" },
  { key: "hi", label: "Hindi" },
  { key: "hr", label: "Croatian" },
  { key: "id", label: "Indonesian" },
  { key: "it", label: "Italian" },
  { key: "ja", label: "Japanese" },
  { key: "ko", label: "Korean" },
  { key: "ms", label: "Malay" },
  { key: "nl", label: "Dutch" },
  { key: "pl", label: "Polish" },
  { key: "pt", label: "Portuguese" },
  { key: "ro", label: "Romanian, Moldavian, Moldovan" },
  { key: "ru", label: "Russian" },
  { key: "sk", label: "Slovak" },
  { key: "sv", label: "Swedish" },
  { key: "ta", label: "Tamil" },
  { key: "tl", label: "Tagalog" },
  { key: "tr", label: "Turkish" },
  { key: "uk", label: "Ukrainian" },
  { key: "zh", label: "Chinese" }
];

export const LanguageOptionsJogAI= [
  { key: "en", label: "English" },
  { key: "bengali", label: "Bengali" },
  { key: "de", label: "German" },
  { key: "filipino", label: "Filipino" },
  { key: "fr", label: "French" },
  { key: "hebrew", label: "Hebrew" },
  { key: "hi", label: "Hindi" },
  { key: "id", label: "Indonesian" },
  { key: "it", label: "Italian" },
  { key: "ja", label: "Japanese" },
  { key: "ko", label: "Korean" },
  { key: "latvian", label: "Latvian" },
  { key: "es", label: "Spanish; Castilian" },
  { key: "malayalam", label: "Malayalam" },
  { key: "nl", label: "Dutch" },
  { key: "odia", label: "Odia" },
  { key: "ru", label: "Russian" },
  { key: "sk", label: "Slovak" },
  { key: "telugu", label: "telugu" },
  { key: "ms", label: "Malay" },
  { key: "zh", label: "Chinese" }
]

export const AccentOptions = [
  { key: null, label: "None" },
  { key: "english-swedish", label: "English-Swedish Accent" },
  { key: "canadian", label: "Canadian Accent" },
  { key: "british", label: "British Accent" },
  { key: "default", label: "Default Accent" },
  { key: "kiwi", label: "Kiwi Accent" },
  { key: "american", label: "American Accent" },
  { key: "us-english", label: "US English Accent" },
  { key: "spanish", label: "Spanish Accent" },
  { key: "american-southern", label: "American-Southern Accent" },
  { key: "french", label: "French Accent" },
  { key: "english-italian", label: "English-Italian Accent" },
  { key: "english-american", label: "English-American Accent" },
  { key: "british-essex", label: "British-Essex Accent" }
];

export const VisualStyleOptions= [
  { key: "AvatarBubbleTemplate", label: "Avatar Bubble" },
  { key: "DynamicProductTemplate", label: "Product" },
  { key: "FullScreenTemplate", label: "Full Screen" },
  { key: "GreenScreenEffectTemplate", label: "Green Screen Effect"},
  { key: "VanillaTemplate", label: "Vanilla"}
]

export const getVisualStyleJogAI= (aspect_ratio="9x16")=>{
  if(aspect_ratio=="9x16"){
    return [
      { key: "Full Screen(New)", label: "Full Screen(New)" },
      { key: "Rotary Switch", label: "Rotary Switch"},
      { key: "Floating Avatar", label: "Floating Avatar Voiceover"},
      { key: "UGC Content", label: "UGC Content"},
      { key: "FullScreen", label: "FullScreen"},
    ]
  }
  else if(aspect_ratio=="16x9"){
    return [
      { key: "Floating Avatar Voiceover", label: "Floating Avatar Voiceover"},
      { key: "Simple Product Switch1", label: "Simple Product Switch1" },
      { key: "Simple Product Switch2", label: "Simple Product Switch2" },
      { key: "Avatar Bubble", label: "Avatar Bubble" },
      { key: "Full Screen", label: "Full Screen"},
      { key: "Floationg Avatar", label: "Floationg Avatar"},
      { key: "Inclined Floating Avatar", label: "Inclined Floating Avatar"},
    ]
  }
  else{
    return [
      { key: "Showcasing Products", label: "Showcasing Products" },
      { key: "Video Mixing Featuring Avatars", label: "Video Mixing Featuring Avatars" },
      { key: "Avatar in Video Mixing", label: "Avatar in Video Mixing" },
      { key: "Video Mixing", label: "Video Mixing"},
      { key: "Avatars in All Scenes", label: "Avatars in All Scenes"},
      { key: "Dual-Screen Avatar View", label: "Dual-Screen Avatar View"},
      { key: "Centered Avatar Display", label: "Centered Avatar Display"},
    ]
  }
}

export const VisualStyleOptionsJogAI= [
  { key: "Full Screen(New)", label: "Full Screen(New)" },
  { key: "Avatar Bubble", label: "Avatar Bubble" },
  { key: "Inclined Floating Avatar", label: "Inclined Floating Avatar" },
  { key: "Rotary Switch", label: "Rotary Switch"},
  { key: "Floating Avatar", label: "Floating Avatar"},
  { key: "UGC Content", label: "UGC Content"}
]

let company_id = localStorage.getItem("companyId");

export const company = {
  getCompanyId: () => {console.log("company",company_id); return company_id},
  setCompanyId: (value) => {
    company_id = value;
  }
};

export const sfOnboardingModule = {
  moduleName: "video_widget",
  tutorialLink: "https://example.com/video-widget-tutorial",
  progress: 0,
  isActive: false,
  title: "Create your first video widget",
  description: "Create widgets for web & apps.",
  redirectRoute: "web&App/widgets",
  imageSvg: WidgetSvg,
  key: "widget",
}

export const socialMediaOnboardingModule = {
  moduleName: "social_media_post",
  tutorialLink: "https://example.com/social-media-post-tutorial",
  progress: 0,
  isActive: false,
  title: "Create your social media post",
  description: "Create & schedule social media posts.",
  redirectRoute: "dashboards/socialMedia",
  imageSvg: SocialMediaPostSvg,
  key: "post",
}

export const livestreamOnboardingModule = {
  moduleName: "livestream",
  tutorialLink: "https://example.com/live-stream-tutorial",
  progress: 0,
  isActive: false,
  title: "Create your first livestream.",
  description: "Create and host livestreams.",
  redirectRoute: "livestream/home",
  imageSvg: LivestreamSvg,
  key: "livestream",
}

export const aiOnboaringModule = {
  moduleName: "ai_video",
  tutorialLink: "https://example.com/ai-video-tutorial",
  progress: 0,
  isActive: false,
  title: "Create your first AI Video",
  description:
    "Create engaging videos for your social media using AI.",
  redirectRoute: "studioAI/home",
  imageSvg: AIVideoSvg,
  key: "ai",
}

export const automationOnboardingModule = {
  moduleName: "dm_automation",
  tutorialLink: "https://example.com/automation-tutorial",
  progress: 0,
  isActive: false,
  title: "Create your first DM Automation",
  description:
    "Create automatic response to triggers done on your social media.",
  redirectRoute: "vudio/automation/dashboard",
  imageSvg: DMAutomationSvg,
  key: "automation",
}

export const BackgroundCategoryOptions = [
  { label: "All", value: "All" },
  { label: "AI PROMPT", value: "AI_PROMPT" },
  { label: "Commercial", value: "Commercial" },
  { label: "Conceptual", value: "Conceptual" },
  { label: "Indoor", value: "Indoor" },
  { label: "Outdoor", value: "Outdoor" },
  { label: "Nature", value: "Nature" },
  { label: "Solid Color", value: "Solid Color" },
  { label: "Texture", value: "Texture" },
  { label: "Urban", value: "Urban" }
]

export const AvatarGenderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" }
]

export const AvatarStyleOptions = [
  { label: "None", value: null },
  { label: "Selfie", value: "selfie" },
  { label: "Presenter", value: "presenter" },
  { label: "Other", value: "other" },
]

export const AvatarLocationOptions = [
  { label: "None", value: null },
  { label: "Outdoor", value: "outdoor" },
  { label: "Indoor", value: "indoor" },
  { label: "Other", value: "other" },
]

export const AvatarAgeOptions = [
  { label: "None", value: null },
  { label: "Adult", value: "adult" },
  { label: "Senior", value: "senior" },
]

export const AIVideoShootsAccentOptions = [
  { value: null, label: "None" },
  { value: "english-swedish", label: "English-Swedish Accent" },
  { value: "canadian", label: "Canadian Accent" },
  { value: "british", label: "British Accent" },
  { value: "default", label: "Default Accent" },
  { value: "kiwi", label: "Kiwi Accent" },
  { value: "american", label: "American Accent" },
  { value: "us-english", label: "US English Accent" },
  { value: "spanish", label: "Spanish Accent" },
  { value: "american-southern", label: "American-Southern Accent" },
  { value: "french", label: "French Accent" },
  { value: "english-italian", label: "English-Italian Accent" },
  { value: "english-american", label: "English-American Accent" },
  { value: "british-essex", label: "British-Essex Accent" }
];

export const AvatarEthincityOptions = [
  { label: "None", value: null },
  { label: "European", value: "european" },
  { label: "African", value: "african" },
  { label: "South Asian", value: "south_asian" },
  { label: "East Asian", value: "east_asian" },
  { label: "Middle Eastern", value: "middle_eastern" },
  { label: "South American", value: "south_american" },
  { label: "North American", value: "north_american" }
]

export const AvatarAspectRatio = [
    {
        value: "9x16",
        label: "9:16"
    },
    {
        value: "16x9",
        label: "16:9"
    },
    {
        value: "1x1",
        label: "1:1"
    }
]

export const checkRouteIncluded = (routeString = "")=>{
  return window.location.href.includes(routeString)
}

export const MurfVoiceLanguages = [
  { label: "None", value: null },
  { label: "English US & Canada", value: "English - US & Canada" },
  { label: "English UK", value: "English - UK" },
  { label: "English Australia", value: "English - Australia" },
  { label: "English India", value: "English - India" },
  { label: "English Scotland", value: "English - Scotland" },
  { label: "Spanish Spain", value: "Spanish - Spain" },
  { label: "Spanish Mexico", value: "Spanish - Mexico" },
  { label: "French France", value: "French - France" },
  { label: "German Germany", value: "German - Germany" },
  { label: "Italian Italy", value: "Italian - Italy" },
  { label: "Portuguese Brazil", value: "Portuguese - Brazil" },
  { label: "Romanian Romania", value: "Romanian - Romania" },
  { label: "Turkish Turkey", value: "Turkish - Turkey" },
  { label: "Hindi India", value: "Hindi - India" },
  { label: "Indonesian Indonesia", value: "Indonesian - Indonesia" },
  { label: "Greek Greece", value: "Greek - Greece" },
  { label: "Polish Poland", value: "Polish - Poland" },
  { label: "Dutch Netherlands", value: "Dutch - Netherlands" },
  { label: "Bengali India", value: "Bengali - India" },
  { label: "Tamil India", value: "Tamil - India" },
  { label: "Bulgarian Bulgaria", value: "Bulgarian - Bulgaria" },
  { label: "Croatian Croatia", value: "Croatian - Croatia" },
  { label: "Korean South Korea", value: "Korean - South Korea" },
  { label: "Japanese Japan", value: "Japanese - Japan" },
  { label: "Chinese China", value: "Chinese - China" },
  { label: "Slovak Slovakia", value: "Slovak - Slovakia" },
]

export const MurfVoiceGenders = [
  { label: "All Genders", value: null },
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Non Binary", value: "NonBinary" },
]

export const MurfVoiceStyles = [
  { label: "None", value: null },
  { label: "Promo", value: "Promo" },
  { label: "Conversational", value: "Conversational" },
  { label: "Calm", value: "Calm" },
  { label: "Narration", value: "Narration" },
  { label: "Storytelling", value: "Storytelling" },
  { label: "Sad", value: "Sad" },
  { label: "Angry", value: "Angry" },
  { label: "Newscast", value: "Newscast" },
  { label: "Documentary", value: "Documentary" },
  { label: "Inspirational", value: "Inspirational" },
  { label: "Luxury", value: "Luxury" },
  { label: "Terrified", value: "Terrified" },
  { label: "Furious", value: "Furious" },
  { label: "General", value: "General" },
  { label: "Friendly", value: "Friendly" },
  { label: "Affectionate", value: "Affectionate" },
  { label: "Assistant", value: "Assistant" },
  { label: "Sports Commentary", value: "Sports Commentary" },
]

export const MurfVoiceAgeGroups = [
  { label: "All Group", value: null },
  { label: "Young Adult", value: "Young Adult" },
  { label: "Middle-Aged", value: "Middle-Aged" },
]
